import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import JobsList from './JobsList';
import JobDataService from "./services/job.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import TopAndSideBar from './TopAndSideBar';
import { NewHeader } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class Jobs extends Component {

  constructor(props) {
    super(props);
    this.onChangeJobFilterByDescr = this.onChangeJobFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);

    this.state = {
      listOfJobs: null,
      JobFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.JobFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.JobFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeJobFilterByDescr(e) {
    this.setState({
        JobFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.JobFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  performSearch = (descr,sortfield,sorttype) => {
    JobDataService.getJobByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfJobs: response.data
        });
        console.log(this.state.listOfJobs);
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"Jobs"}/>
        <div style={{padding:"0 8vw",}}>
          <Row>
            <Col lg={true}>
              <FormLabel className='mb-2'>Filter by Job Title:</FormLabel>       
              <FormControl type="text" name="filterbyjobtitle" id="filterbyjobtitle" onChange={this.onChangeJobFilterByDescr}></FormControl>
            </Col>
            <Col lg={true}>
              <FormLabel className='mb-2'>Sort By:</FormLabel>       
                <FormControl as='select' onChange={this.onChangeSortField}>
                  <option value="id">Job ID</option>
                  <option value="jobtitle">Job Title</option>
                </FormControl>
            </Col>
            
            <Col sm={true}>
              <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
              <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
            </Col>          
          </Row>

          <Link to="/new-job" className="mr-2 btn btn-primary">New Job</Link>            
          <Button className="m-2 btn btn-primary">Export</Button>        
          <Row>
            <JobsList mode={0} listOfJobs = {this.state.listOfJobs} />      
          </Row>
        </div>      
      </div>
      </>
    )
  }
}

export default Jobs;